import Util from "../util/util";

export default class Offers {

	static getHolderSelectors = () => ['.offers-element'];

	/** @type {HTMLElement} */
	#holderElement;

	/** @param {HTMLElement} holderElement */
	constructor(holderElement) {
		this.#holderElement = holderElement;
		const controlsElement = this.#holderElement.querySelector('.card-slider-controls');
		this.#holderElement.querySelectorAll('.splide').forEach((s) => {
			Util.sliderControls(s, controlsElement);
		});
	}

}
